//记得在 src\components\lang\zhLoad.js 里面添加对象
const userType= {
  userTypeName:'用户类型',
  accessPcInnerNetFlagName:'pc是否内网访问',
  accessPcOuterNetFlagName: 'pc是否外网访问',
  accessQiyeWxFlagName:'企业微信是否访问',
  accessMiniappFlagName: '微信小程序是否访问',
  accessPdaFlagName: 'PDA是否访问',
  msg:{}
};
export default userType



// WEBPACK FOOTER //
// ./src/page/auth/userType/lang/userType.en.js